import './index.scss';

import {formatDate} from '../../helpers/date';
import {
  clearError,
  validateInputEmptyEmail,
  validateInputEmptyLength,
  validateInputEmptyPhone,
}                   from '../../helpers/validators';
import dropdown     from '../dropdown';
import {$_body}     from '../../helpers/dom';
import {emSend}     from '../../helpers/emarketeer';

const COMPONENT = 'em_form';

export default () => {
  $(`.${COMPONENT}`).each((item, component) => {
    //region Components

    const $component = $(component);

    const $parentModal = $component.closest('.overlay-box');

    const $form = $component.find('form');
    const $firstName = $form.find('.input_firstname');
    const $firstNameField = $firstName.closest('.field');
    const $lastName = $form.find('.input_lastname');
    const $lastNameField = $lastName.closest('.field');
    const $company = $form.find('.input_company');
    const $email = $form.find('.input_email');
    const $emailField = $email.closest('.field');
    const $phone = $form.find('.input_phone');
    const $phoneField = $phone.closest('.field');
    const $dropdown = dropdown($component)[0];
    const $permissionCheck = $form.find('.checkbox_permission');
    const $button = $component.find(`.${COMPONENT}__btn-submit`);

    const $successDialog = $component.find(`.${COMPONENT}__success_message--modal`);
    const $successContent = $component.find(`.${COMPONENT}__success_message`);

    //endregion

    //region Private

    let _busy = false;

    /** @type {EMData} */
    const data = $component.data(COMPONENT) || {};
    const eMPredefined = data.EMPredefined;
    const loadingText = String($button.attr('data-loading-text'));
    const originalText = $button.text();

    /** @type {JQuery<HTMLElement>} */
    let $invoker;

    //endregion

    //region Initialize

    $successContent.hide();

    if ($parentModal)
    {
      $parentModal
        .on('show.bs.modal', (e) => {
          $invoker = $(e.relatedTarget);

          $firstName.val('');
          $lastName.val('');
          $company.val('');
          $email.val('');
          $phone.val('');

          clearError($firstNameField);
          clearError($lastNameField);
          clearError($emailField);
          clearError($phoneField);
          $successContent.hide();
          $form.show();
        });
    }

    if ($successDialog)
    {
      $successDialog.remove();
      $successDialog.appendTo($_body());

      $successDialog
        .on('show.bs.modal', () => {
          //parentModal.modal('hide');
        })
        .on('hidden.bs.modal', () => {
          //parentModal.modal('show');
          $parentModal.modal('hide');
        });
    }

    $form.on('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();

      submit();

      return false;
    });

    if ($permissionCheck.length)
    {
      $button.prop('disabled', true);

      $permissionCheck.on('change', () => {
        $button.prop('disabled', !$permissionCheck.is(':checked'));
      });
    }

    //endregion

    //region Functions

    function busy(value = true) {
      _busy = value;

      if (_busy)
      {
        $button.text(loadingText);
      }
      else
      {
        $button.text(originalText);
      }

      $firstName.prop('disabled', value);
      $lastName.prop('disabled', value);
      $email.prop('disabled', value);
      $phone.prop('disabled', value);
      $button.prop('disabled', value);
    }

    function submit() {
      if (_busy || !validate())
      {
        return;
      }

      busy(true);

      const extraData = $invoker.data(COMPONENT) || {};

      const clientDate = formatDate();

      const company = String($company.val()).trim();

      let phone = String($phone.val()).trim();
      if (phone)
      {
        phone = '0045 ' + phone;
      }

      let params = {};

      for (const key in eMPredefined)
      {
        if (eMPredefined.hasOwnProperty(key))
        {
          params[key] = eMPredefined[key];
        }
      }

      params[data.EMfirstNameField] = String($firstName.val()).trim();
      params[data.EMlastNameField] = String($lastName.val()).trim();
      if (company)
      {
        params[data.EMcompanyField] = company;
      }

      params[data.EMemailField] = String($email.val()).trim();
      params[data.EMtelephoneField] = phone;

      params[data.EMpermissionDateField] = clientDate;

      for (const dataKey in extraData) {
        if (data.hasOwnProperty(dataKey)) {
          params[data[dataKey]] = extraData[dataKey];
        }
      }

      if ($dropdown && data.EMEvents)
      {
        const event = data.EMEvents[$dropdown.getIndex()];
        if (event)
        {
          for (const key in event)
          {
            if (event.hasOwnProperty(key))
            {
              params[key] = String(event[key]).trim();
            }
          }
        }
      }

      emSend(params, () => {
        $firstName.val('');
        $lastName.val('');
        $email.val('');
        $phone.val('');

        $successContent.show();
        $form.hide();
        $successDialog.modal('show');

        busy(false);
      });
    }

    function validate() {
      let valid = true;

      valid &= validateFirstName();
      valid &= validateLastName();
      valid &= validateEmail();
      valid &= validatePhone();

      return valid;
    }

    function validateFirstName() {
      return validateInputEmptyLength($firstName, $firstNameField, 2);
    }

    function validateLastName() {
      return validateInputEmptyLength($lastName, $lastNameField, 2);
    }

    function validateEmail() {
      return validateInputEmptyEmail($email, $emailField);
    }

    function validatePhone() {
      return validateInputEmptyPhone($phone, $phoneField);
    }

    //endregion
  });
};
